import { customerConfig } from "../../customerConfig";

const CustomerStatus = ({ value, size = "small" }) => {
  const getStatusStyles = (status) => {
    switch (status) {
      case customerConfig.filterTabs.awaitingVerification.code:
        return {
          bg: "bg-[#FDF3D7]",
          text: "text-[#6B5618]",
          border: "border-[#FDF3D7]",
          label: customerConfig.filterTabs.awaitingVerification.label,
        };
      case customerConfig.filterTabs.verified.code:
        return {
          bg: "bg-[#C4E9E3]",
          text: "text-[#0B662C]",
          border: "border-[#C4E9E3]",
          label: customerConfig.filterTabs.verified.label,
        };
      case customerConfig.filterTabs.deactivated.code:
        return {
          bg: "bg-[#DBDBDB]",
          text: "text-[#6D7C94]",
          border: "border-[#DBDBDB]",
          label: customerConfig.filterTabs.deactivated.label,
        };
      case customerConfig.filterTabs.notSubmitted.code:
        return {
          bg: "bg-[#F0F6FC]",
          text: "text-primary1",
          border: "border-[#F0F6FC]",
          label: customerConfig.filterTabs.notSubmitted.label,
        };
      case customerConfig.filterTabs.awaitingDocuments.code:
        return {
          bg: "bg-gray-200",
          text: "text-gray-700",
          border: "border-gray-700",
          label: customerConfig.filterTabs.awaitingDocuments.label,
        };
      default:
        return {
          bg: "bg-gray-200",
          text: "text-gray-700",
          border: "border-gray-700",
          label: value || "Unknown Status",
        };
    }
  };

  const { bg, text, border, label } = getStatusStyles(value);

  const sizeClasses =
    size === "large" ? `text-sm px-4 py-2` : "text-xs px-2 py-1";

  return (
    <div
      className={`rounded-md mb-3 w-fit pb-1 text-center ${bg} ${
        size === "large" ? `border py-2 pb-[7px] px-2 ${border}` : ""
      }`}
    >
      <span className={`font-bold rounded-md ${text} ${sizeClasses}`}>
        {label}
      </span>
    </div>
  );
};

export default CustomerStatus;
